/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocationsUpdateRequest } from '../../models/locations-update-request';
import { LocationsUpdateResponse } from '../../models/locations-update-response';

export interface UpdateLocations$Params {
      body: LocationsUpdateRequest
}

export function updateLocations(http: HttpClient, rootUrl: string, params: UpdateLocations$Params, context?: HttpContext): Observable<StrictHttpResponse<LocationsUpdateResponse>> {
  const rb = new RequestBuilder(rootUrl, updateLocations.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LocationsUpdateResponse>;
    })
  );
}

updateLocations.PATH = '/api/v1/location';
